var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnvelopeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m14.475 4.502-4.56 4.56a2.71 2.71 0 0 1-3.83 0l-4.56-4.56c-.008.086-.025.163-.025.248v6.5a2.71 2.71 0 0 0 2.708 2.708h7.584A2.71 2.71 0 0 0 14.5 11.25v-6.5c0-.085-.017-.162-.025-.248"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m9.15 8.296 4.947-4.948a2.7 2.7 0 0 0-2.305-1.306H4.208a2.7 2.7 0 0 0-2.305 1.306l4.948 4.948a1.63 1.63 0 0 0 2.298 0"
})));
export { SvgEnvelopeIcon as ReactComponent };
export default __webpack_public_path__ + "152371515f08bf51f98254be5fee8d4c.svg";